export default "__VITE_ASSET__CFvPmdYX__"